import React, { Component } from 'react';
import { Text, ViewBox } from './../common';
import styled from 'styled-components';
import { Flex, Box } from 'rebass';
import { colors } from '../../tailwind';
import moment from 'moment';
import _ from 'lodash';
import Select from './../common/FormComponents/SelectMinimal';
import Button from './../common/FormComponents/Button';
import { buildAvatarPath } from '../../helpers/photoutils';
import Link from '../../components/Link';
import { host } from '../../config';
import { addTime } from '../../helpers/timeFormatHelpers';

const date = moment();
const initialYear = date.format('YYYY');
const defaultMonthOption = {
  value: 0,
  label: 'All',
};
const defaultYearOption = {
  value: initialYear,
  label: initialYear,
};

const defaultFormat = {
  value: -1,
  label: 'All Listings',
};

export default class DashboardListings extends Component {
  constructor() {
    super();

    this.state = {
      selectedMonth: defaultMonthOption,
      selectedYear: defaultYearOption,
      selectedTimeFrame: 'month',
      selectedFormat: defaultFormat,
      refsSet: false,
      dayScrollOffset: 0,
      selectedDay: 0,
    };

    this.innerScroll = React.createRef();
    this.outerScroll = React.createRef();
  }

  radioChanged = e => {
    this.setState({
      selectedTimeFrame: e.target.value,
    });
  };

  componentDidUpdate(prevProps) {
    if (
      this.state.selectedDay === 0 &&
      this.state.selectedTimeFrame === 'day'
    ) {
      this.selectFirstDay();
    }
  }

  selectFirstDay = () => {
    const days = this.props.reservations.map(x =>
      moment(x.checkIn) > moment(x.checkOut) ? x.checkOut : x.checkIn,
    );
    const daysSorted = _.sortBy(days, x => x);
    const selectedDay = moment(daysSorted[0]).date();
    this.setState({
      selectedDay,
    });
  };

  monthChanged = selectedMonth => {
    const { filtersChanged } = this.props;
    this.setState({ selectedMonth }, () => {
      filtersChanged({ month: selectedMonth.value });
    });
  };

  yearChanged = selectedYear => {
    const { filtersChanged } = this.props;
    this.setState({ selectedYear }, () => {
      filtersChanged({ year: selectedYear.value });
    });
  };

  renderTimeRangeSelection(reservations) {
    //Build available months
    let date = moment('1/1/2019');
    const dateMonthOptions = [
      {
        value: 0,
        label: 'All',
      },
    ];
    _.times(12, num => {
      dateMonthOptions.push({
        value: num + 1,
        label: date.format('MMMM'),
      });
      date.add(1, 'month');
    });

    //Build available years
    date = moment();
    const dateYearOptions = [];
    const dateDiffYear = date.year() - 2019 + 2;
    _.times(dateDiffYear, () => {
      dateYearOptions.push({
        value: date.format('YYYY'),
        label: date.format('YYYY'),
      });
      date.add(1, 'year');
    });

    const itemValues = _.chain(reservations)
      .map(x => ({
        label: (x.listData && x.listData.title) || 'Deleted item"',
        value: x.id,
      }))
      .uniqBy(x => x.value)
      .value();
    itemValues.unshift(defaultFormat);

    const { selectedTimeFrame } = this.state;
    return (
      <Flex
        style={{ height: '64px' }}
        justifyContent="space-between"
        alignItems="center"
        pr="24px"
      >
        <div className="f-sc">
          <Select
            defaultValue={defaultMonthOption}
            onChange={this.monthChanged}
            options={dateMonthOptions}
            width="150px"
            boldFirst
          />
          <Select
            defaultValue={defaultYearOption}
            onChange={this.yearChanged}
            options={dateYearOptions}
            width="96px"
          />
        </div>
        <Flex alignItems="center" justifyContent="flex-end">
          <RadioContainer>
            <input
              type="radio"
              name="type"
              value="month"
              checked={selectedTimeFrame === 'month'}
              style={{
                marginBottom: 7,
                transform: 'scale(.7)',
                cursor: 'pointer',
              }}
              onChange={this.radioChanged}
            />
            <Text t_title ml={'14px'} mr={'24px'}>
              {' '}
              Month
            </Text>
            <input
              type="radio"
              name="type"
              value="day"
              checked={selectedTimeFrame === 'day'}
              style={{
                marginBottom: 7,
                transform: 'scale(.7)',
                cursor: 'pointer',
              }}
              onChange={this.radioChanged}
            />
            <Text t_title ml={'14px'}>
              {' '}
              Day
            </Text>
          </RadioContainer>
          <Select
            defaultValue={defaultFormat}
            onChange={selectedFormat => {
              this.setState({ selectedFormat });
            }}
            options={itemValues}
          />
        </Flex>
      </Flex>
    );
  }

  scrollRight = () => {
    const { selectedMonth, selectedYear } = this.state;
    const daysCount = moment(
      selectedMonth.value + ' ' + selectedYear.value,
    ).daysInMonth();

    const innerWidth = this.innerScroll.current
      ? this.innerScroll.current.offsetWidth
      : 55;
    const outerWidth = this.outerScroll.current
      ? this.outerScroll.current.offsetWidth
      : 555;

    const totalWidth = daysCount * innerWidth;
    const visibleItemCount = outerWidth / innerWidth;
    const translateChange = (visibleItemCount / 2) * innerWidth * -1;
    let computedChange = this.state.dayScrollOffset + translateChange;

    if (computedChange < -totalWidth - translateChange / 2) {
      computedChange = -totalWidth - translateChange / 2;
    }

    this.setState({
      dayScrollOffset: computedChange,
    });
  };

  scrollLeft = () => {
    const innerWidth = this.innerScroll.current
      ? this.innerScroll.current.offsetWidth
      : 55;
    const outerWidth = this.outerScroll.current
      ? this.outerScroll.current.offsetWidth
      : 555;

    const visibleItemCount = outerWidth / innerWidth;
    const translateChange = (visibleItemCount / 2) * innerWidth;
    let computedChange = this.state.dayScrollOffset + translateChange;
    if (computedChange > 0) {
      computedChange = 0;
    }

    this.setState({
      dayScrollOffset: computedChange,
    });
  };

  setSelectedDay = day => {
    this.setState({
      selectedDay: day,
    });
  };

  renderDaySelection(reservations, format) {
    const { scheduleMode } = this.props;
    const {
      selectedMonth,
      selectedYear,
      dayScrollOffset,
      selectedDay,
    } = this.state;
    const daysCount = moment(selectedMonth.value).daysInMonth();
    const thisMonthsReservations = {};
    const selectedMonthNum =
      selectedMonth.value > 0 ? selectedMonth.value : moment().month();
    reservations.forEach(x => {
      if (format.value >= 0 ? x.id !== format.value : false) {
        return;
      }
      const inDay = moment(x.checkIn);
      const outDay = moment(x.checkOut);
      const resMonth = inDay.month();
      const resDay = inDay.date();
      if (resMonth === selectedMonthNum) {
        thisMonthsReservations[resDay] = true;
      }
      const resOutMonth = outDay.month();
      const resOutDay = outDay.date();
      if (!scheduleMode && resOutMonth === selectedMonthNum) {
        thisMonthsReservations[resOutDay] = true;
      }
    });

    return (
      <Flex bg="#efefef" style={{ height: '64px' }} alignItems="center">
        <Box>
          <ChevronButton onClick={this.scrollLeft}>
            <i className="far fa-chevron-left" />
          </ChevronButton>
        </Box>
        <Box style={{ overflow: 'hidden' }}>
          <div
            className="f-sc"
            ref={this.outerScroll}
            style={{
              transform: `translateX(${dayScrollOffset}px)`,
              transition: 'transform ease-out 0.75s',
            }}
          >
            {_.times(daysCount, num => {
              const hasReservation = thisMonthsReservations.hasOwnProperty(
                num + 1,
              );
              const isSelectedDay = selectedDay === num + 1;
              return (
                <div
                  ref={num === 0 ? this.innerScroll : null}
                  style={{
                    display: 'inline-block',
                    paddingRight: '5px',
                  }}
                >
                  <Flex
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="flex-end"
                    mt="4px"
                    style={{
                      cursor: hasReservation ? 'pointer' : 'auto',
                      width: 30,
                      height: 30,
                      backgroundColor: isSelectedDay
                        ? colors.primaryDark
                        : 'transparent',
                      borderRadius: 30,
                    }}
                    onClick={
                      hasReservation ? () => this.setSelectedDay(num + 1) : null
                    }
                  >
                    <Text
                      inline
                      large
                      style={{ cursor: 'inherit' }}
                      white={isSelectedDay}
                    >
                      {num + 1}
                    </Text>
                    <div
                      style={{
                        backgroundColor: hasReservation
                          ? colors.primaryDark
                          : 'transparent',
                        borderRadius: 66,
                        width: 4,
                        height: 4,
                        cursor: 'inherit',
                      }}
                    />
                  </Flex>
                </div>
              );
            })}
          </div>
        </Box>
        <Box>
          <ChevronButton onClick={this.scrollRight}>
            <i className="far fa-chevron-right" />
          </ChevronButton>
        </Box>
      </Flex>
    );
  }

  render() {
    const { reservations, loading, userId, scheduleMode } = this.props;
    const { selectedTimeFrame, selectedFormat, selectedDay } = this.state;
    // User filters to get applicable reservations
    const filteredReservations = mapReservations(
      reservations,
      scheduleMode,
      selectedTimeFrame,
      selectedDay,
      selectedFormat,
    );
    // build list Items

    // If no reservations show test data message
    return (
      <div>
        {this.renderTimeRangeSelection(reservations)}
        <Flex flexDirection="column" style={{ maxWidth: '960px' }}>
          {selectedTimeFrame === 'day'
            ? this.renderDaySelection(reservations, selectedFormat)
            : null}

          {(loading && <i className="fa fa-spinner" />) ||
            ((!reservations || !reservations.length) && (
              <Text inline large>
                No reservations found.
              </Text>
            )) || (
              <Flex flex={1} flexDirection="column">
                {buildListItems(
                  filteredReservations,
                  selectedTimeFrame,
                  userId,
                )}
              </Flex>
            )}
        </Flex>
      </div>
    );
  }
}

export function buildListItems(reservations, timeFrame, userId) {
  if (timeFrame === 'day') {
    return reservations.map(x => <ListItem item={x} userId={userId} />);
  }
  const grouped = _.groupBy(reservations, x => x.date);
  const ordered = _.sortBy(Object.keys(grouped), x => new Date(x));
  const Items = _.map(ordered, date => {
    const dayArray = grouped[date];
    const itemDate = dayArray[0].date;
    const cal = moment(itemDate).calendar();
    const dateStr =
      cal === 'Today' || cal === 'Tomorrow'
        ? `${cal}, ${moment(itemDate).format('MMMM D')}`
        : moment(itemDate).format('MMMM D');
    return (
      <div>
        <Text
          sectionheader
          ml="26px"
          style={{ borderTop: `1px solid ${colors.coolGrayLight}` }}
          pt={'24px'}
          mb={2}
        >
          {dateStr}
        </Text>
        {dayArray &&
          dayArray.map(x => <ListItem item={x} month userId={userId} />)}
      </div>
    );
  });
  return Items;
}

function mapReservations(
  reservations,
  scheduleMode,
  timeFrame,
  selectedDay,
  format,
) {
  const matchingStartDates = reservations
    .filter(x => {
      const sDate = moment(x.checkIn);
      const day = sDate.date();
      if (
        (day === selectedDay || timeFrame === 'month' || selectedDay === 0) &&
        (format && format.value >= 0 ? x.id === format.value : true)
      ) {
        return true;
      }
      return false;
    })
    .map(x => {
      const y = { ...x };
      y.isPickup = true;
      y.date = y.checkIn;
      return y;
    });

  const matchingEndDates = reservations
    .filter(x => {
      const sDate = moment(x.checkOut);
      const day = sDate.date();
      if (
        (day === selectedDay || timeFrame === 'month' || selectedDay === 0) &&
        (format && format.value >= 0 ? x.id === format.value : true)
      ) {
        return true;
      }
      return false;
    })
    .map(x => {
      const y = { ...x };
      y.isPickup = false;
      y.date = y.checkOut;
      return y;
    });

  return [...matchingStartDates, ...matchingEndDates];
}

export const ListItem = function(props) {
  const {
    isPickup,
    listData,
    listData: { title = 'deleted item', city = 'unknown', state = 'XYZ' },
    guestData, //: ,
    hostData,
    checkIn,
    checkOut,
    hostId,
    messageData,
    id,
  } = props.item;

  const { userId } = props;

  let itemInfo = {};
  let isHost = false;
  if (hostId === userId) {
    itemInfo = guestData;
  } else {
    itemInfo = hostData;
    isHost = true;
  }
  const { displayName, picture, profileId, firstName } = itemInfo;
  console.log('props.item', props.item);
  let exchangeTime = addTime(props.item.date, props.item.time);
  const exchangeTimeStr = moment(exchangeTime).format('ddd Do - hh:mm a');
  // Pickup From, Pickup By
  // Dropoff To, Dropoff By

  return (
    <ListItemInner month={props.month} className="hover-list-hover">
      <Flex justifyContent="space-between" alignItems="center">
        <Flex flexDirection="column">
          <Flex id="left" alignItems="center">
            <i id="calIcon" className="far fa-calendar-alt" />

            <Text id="upoff" bold pl="20px">
              {isHost ? '' : 'You '}
              {isPickup ? 'Pickup' : 'Dropoff'}
              {isHost ? ' by ' + firstName : ''}
            </Text>
            <div
              id="hyphen1"
              style={{
                width: 4,
                height: 4,
                borderRadius: 4,
                marginLeft: 14,
                marginRight: 14,
                backgroundColor: '#a8a8a8',
              }}
            />
            <Link to={'/details/' + listData.id}>
              <Text id="title" primaryDark clickable>
                {title}
              </Text>
            </Link>
            <div
              id="hyphen2"
              style={{
                width: 4,
                height: 4,
                borderRadius: 4,
                marginLeft: 14,
                marginRight: 14,
                backgroundColor: '#a8a8a8',
              }}
            />

            <Text id="time">{exchangeTimeStr}</Text>
          </Flex>

          <Flex alignItems="center">
            <i
              className="fas fa-map-marker-alt"
              style={{ fontSize: '8px', marginLeft: '3px' }}
            />
            <Text ml="20px">
              {city}, {state && state.toUpperCase()}
            </Text>
          </Flex>
        </Flex>
        <Flex id="right" alignItems="center">
          <Link to={'/users/show/' + profileId}>
            <Text id="renterName" large pr={4} clickable>
              {displayName}
            </Text>
          </Link>
          <Link to={'/inbox/' + (messageData && messageData.id)}>
            <i id="emailIcon" className="fas fa-envelope grayDark pr-mx" />
          </Link>
          <Link to={'/users/show/' + profileId}>
            <AvatarImage
              src={buildAvatarPath(picture)}
              alt="photo"
              id="ownerAvatar"
            />
          </Link>
        </Flex>
      </Flex>
    </ListItemInner>
  );
};

const AvatarImage = styled.img`
  width: 48px;
  height: 48px;
  border: solid 1.5px ${colors.primaryDark};
  border-radius: 48px;
  object-fit: cover;
  cursor: pointer;
`;

const ListItemInner = styled.div`
  border-bottom: ${p => (p.month ? '0px' : `1px solid ${colors.coolGrayLight}`)}
  padding-top: ${p => (p.month ? '7px' : '28px')};
  padding-bottom: ${p => (p.month ? '7px' : '28px')};
  padding-left: 27px;
  padding-right: 27px;
`;

const RadioContainer = styled(Flex)`
  input[type='radio'] {
    outline: 0px solid green;
  }
  input[type='radio']:checked {
    border: 0px;
  }
`;

const ChevronButton = styled.button`
  width: 64px;
  height: 64px;
  background-color: transparent;
  border: 0px;
  color: ${colors.grayDarkMedium};
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/components_new/dashboard/DashboardListings.js